import { AppThunk } from '@/store'
import { request } from '@/store/actions'

import {
  CREATE_NOTIFICATION_SOURCE,
  DELETE_NOTIFICATION_SOURCE,
  FETCH_NOTIFICATION_SOURCES,
  UPDATE_NOTIFICATION_SOURCE
} from './actionTypes'

type NotificationSource = {
  title: string
  iconUrl: string
}
export const fetchNotificationSources = (): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        '',
        FETCH_NOTIFICATION_SOURCES,
        {
          method: 'GET',
          headers: { 'x-workgrid-space': ':spaceId' }
        },
        {
          args: { spaceId: ':spaceId' },
          service: 'notificationSources'
        }
      )
    )
  }
}

export const createNotificationSource = (notificationSource: NotificationSource): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        '',
        CREATE_NOTIFICATION_SOURCE,
        {
          method: 'POST',
          headers: { 'x-workgrid-space': ':spaceId' },
          body: notificationSource
        },
        {
          args: { spaceId: ':spaceId' },
          service: 'notificationSources'
        }
      )
    )
  }
}

export const deleteNotificationSource = (id: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/${id}`,
        DELETE_NOTIFICATION_SOURCE,
        {
          method: 'DELETE',
          headers: { 'x-workgrid-space': ':spaceId' }
        },
        {
          args: { id, spaceId: ':spaceId' },
          service: 'notificationSources'
        }
      )
    )
  }
}

export const updateNotificationSource = (id: string, notificationSource: NotificationSource): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/${id}`,
        UPDATE_NOTIFICATION_SOURCE,
        {
          method: 'PUT',
          headers: { 'x-workgrid-space': ':spaceId' },
          body: notificationSource
        },
        {
          args: { spaceId: ':spaceId' },
          service: 'notificationSources'
        }
      )
    )
  }
}
